import { useState, CSSProperties } from "react";
/* import FadeLoader from "react-spinners/FadeLoader";
import MoonLoader from "react-spinners/MoonLoader"; */
import BeatLoader from "react-spinners/BeatLoader";
import DotLoader from "react-spinners/DotLoader";
import PuffLoader from "react-spinners/PuffLoader";

const Spinner = ({ position, transparent = true, backgroundColor = "", loadingState = null }) => {
  const style = {
    container: {
      position: position,
      top: "0",
      left: "0",
      right: "0",
      bottom: "0",
      margin: "",
      background: transparent ? "rgba(0, 0, 0, 0.35)" : "rgba(255, 255, 255, 1)",
      backgroundColor: backgroundColor,
      backdropFilter: "blur(0.8px)",

      "-webkitBackdropFilter": "blur(13.4px)",
      display: "flex",
      flexDirection: "column",
      justifyContent: "center",
      gap: "10px",
      alignItems: "center",
    },
  };
  return (
    <>
      <div style={style.container}>
        <DotLoader color={"#0E49B5"} />
        {loadingState && <p style={{ fontSize: "0.85rem", color: "rgb(24, 24, 24)", fontWeight: "600" }}>{loadingState}</p>}
      </div>
    </>
  );
};

export default Spinner;

export const ButtonLoader = ({ color = "white" }) => {
  const style = {
    container: {
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      height: "100%",
      width: "100%",
    },
  };

  return (
    <>
      <div style={style.container}>
        <BeatLoader color={color} size={10} />
      </div>
    </>
  );
};

export const ImageUploadLoader = ({ color = "#0E49B5" }) => {
  const style = {
    container: {
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      height: "100%",
      width: "100%",
    },
  };

  return (
    <>
      <div style={style.container}>
        <PuffLoader color={color} size={30} />
      </div>
    </>
  );
};

export const ButtonLoaderII = ({ size = 16, color = "#ffffff" }) => (
  <svg width={size} height={size} viewBox='0 0 100 100' xmlns='http://www.w3.org/2000/svg'>
    <circle cx='50' cy='50' r='40' fill='none' stroke={color} strokeWidth='8' strokeDasharray='251.2' strokeDashoffset='62.8' strokeLinecap='round'>
      <animateTransform attributeName='transform' type='rotate' from='0 50 50' to='360 50 50' dur='1s' repeatCount='indefinite' />
    </circle>
  </svg>
);
